import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AddUserPayload } from 'app/services/firebase/functions/addUser';

export type JoinBetaFormValues = AddUserPayload;

interface JoinBetaData {
  data: JoinBetaFormValues | null;
}

const initialState: JoinBetaData = {
  data: null,
};

const joinBetaDataSlice = createSlice({
  name: 'joinBetaData',
  initialState,
  reducers: {
    setJoinBetaData: (state, action: PayloadAction<JoinBetaFormValues>) => {
      state.data = action.payload;
    },
  },
});

export const { setJoinBetaData } = joinBetaDataSlice.actions;

export default joinBetaDataSlice.reducer;
